import { makeStyles } from '@fluentui/react-components';

//TODO: Removing fluentui/north-start dependency. Need proper styling to align it center.
export const useNoAccessPageStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexGrow: 1,
    marginTop: '133px',
    textAlign: 'center',
    columnGap: '16px',
    rowGap: '36px',
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexGrow: 1,
    textAlign: 'center',
    columnGap: '16px',
  },
});
